import {
  SvgIconComponent,
  HomeOutlined as HouseIcon,
  StairsOutlined as StairsIcon,
  ParkOutlined as OutdoorsIcon,
  BathtubOutlined as BathroomIcon,
  SoupKitchenOutlined as KitchenIcon,
  WeekendOutlined as LivingRoomIcon,
  BedOutlined as BedroomIcon,
  MeetingRoomOutlined as EntranceIcon,
  BalconyOutlined as BalconyIcon,
  ShowerOutlined as BathroomShowerIcon,
  WcOutlined as ToiletSeatIcon,
  LocalLaundryServiceOutlined as LaundryMachine1Icon,
  WaterOutlined as WaterFountainJetIcon,
  WashOutlined as LockerRoomWashHands1Icon,
  LightbulbOutlined as LightBulbIcon,
  WeekendOutlined as SofaDoubleIcon,
  ThermostatOutlined as ACHeatIcon,
  TerrainOutlined as MaterialStoneIcon,
  BoltOutlined as NuclearEnergyMessageIcon,
  KitchenOutlined as AppliancesFridgeIcon,
  RestaurantOutlined as VegetablesPlateIcon,
  OutdoorGrillOutlined as AppliancesStove,
  AirOutlined as RenewableEnergyWindTurbine,
  WaterDamageOutlined as WaterFountainSinkIcon,
  SettingsRemoteOutlined as ModernTvRemoteIcon,
  KeyOutlined as RealEstateActionHouseKeyIcon,
  LocalFireDepartmentOutlined as MatchesFireIcon,
  YardOutlined as GardeningWateringPipeIcon,
  LocalParkingOutlined as ParkingP1Icon,
  ElevatorOutlined as LiftIcon,
  MarkunreadMailboxOutlined as MailboxInIcon,
  StairsOutlined as StairsAscendIcon,
  LocalLaundryServiceOutlined as LaundryMachineIcon,
  WarehouseOutlined as WarehouseStorageIcon,
  DeleteOutlined as GarbageBinIcon,
  DirectionsBikeOutlined as BikingPersonIcon,
  PetsOutlined as SkunkIcon,
  ApartmentOutlined as BuildingIcon,
  CabinOutlined as FamilyOutdoorsPlayhouseIcon,
  ChildCareOutlined as FamilyOutdoorsTeeterIcon,
  AcUnitOutlined as IceRoadIcon,
  LocalLaundryServiceOutlined as LaundryMachine2Icon,
  NotificationsActiveOutlined as SafetyFireAlarm,
  BathroomOutlined as BathroomMirrorCabinet,
  OpacityOutlined as HumidityHigh,
  MeetingRoomOutlined as ArchitectureDoor,
  PlumbingOutlined as WaterProtectionFaucet,
  BuildOutlined as WenchIcon,
  HardwareOutlined as HardwareNutsRound,
  BlenderOutlined as AppliancesSlowCooker,
  RamenDiningOutlined as StoveInductionPot,
  AcUnitOutlined as TemperatureSnowflake,
  KeyOutlined as LoginKeys,
  PestControlOutlined as PestBusters,
  MicrowaveOutlined as AppliancesOven,
  SquareFootOutlined as RealEstateDimensionsPlan1,
  DeleteOutlined as GarbageThrow,
  StairsOutlined as StairsPersonDescend,
  LocalFloristOutlined as FocusFlower,
  WarehouseOutlined as WarehouseStorage2,
  FormatPaintOutlined as ColorRollingBrush,
  ConfirmationNumberOutlined as WayfindingTicket,
  SentimentVeryDissatisfiedOutlined as SmileyAngry,
  HeadsetMicOutlined as HeadphonesSupport,
  GrassOutlined as PlantSad,
  RamenDiningOutlined as InductionPot,
  HandymanOutlined as ConstructionDrill,
  QuizOutlined as FolderQuestion,
  PsychologyOutlined as ScienceBrain,
} from "@mui/icons-material";

import { CustomerComplaintReason } from "../types/Ticket";

export type FailureType = {
  categoryKey: string;
  icon: SvgIconComponent;
};

export const problemKey = "problem";
export const customerComplaintKey = "customerComplaint";
export const generalKey = "general";

export enum FailureCategoryLabelKey {
  CATEGORY = "failure.category.category",
  ROOM = "failure.category.room",
  TYPE = "failure.category.type",
  SPECIFIC_PROBLEM = "failure.category.problem",
}

export const failure: { [key: string]: FailureType } = {
  //SERVICE REQUEST TYPE
  // NORWAY
  "93": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: HouseIcon,
  },
  "94": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: StairsIcon,
  },
  "95": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: OutdoorsIcon,
  },
  // DENMARK
  "119": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: HouseIcon,
  },
  "120": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: StairsIcon,
  },
  "121": {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: OutdoorsIcon,
  },
  //rooms
  // NORWAY
  "10732": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: BathroomIcon,
  },
  "10733": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: KitchenIcon,
  },
  "10734": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: LivingRoomIcon,
  },
  "10735": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: BedroomIcon,
  },
  "10736": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: EntranceIcon,
  },
  "10737": {
    categoryKey: FailureCategoryLabelKey.ROOM,
    icon: BalconyIcon,
  },
  // DANMARK
  "11130": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },
  "11131": { categoryKey: FailureCategoryLabelKey.ROOM, icon: BathroomIcon },
  "11132": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },
  "11134": { categoryKey: FailureCategoryLabelKey.ROOM, icon: KitchenIcon },
  "11135": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },
  "11137": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },
  "11138": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },
  "11139": { categoryKey: FailureCategoryLabelKey.ROOM, icon: EntranceIcon },

  //category
  // NORWAY
  "10738": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BathroomShowerIcon,
  },
  "10739": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ToiletSeatIcon,
  },
  "10740": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LaundryMachine1Icon,
  },
  "10741": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterFountainJetIcon,
  },
  "10834": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LockerRoomWashHands1Icon,
  },
  "10742": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LockerRoomWashHands1Icon,
  },
  "10743": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LightBulbIcon,
  },
  "10744": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: SofaDoubleIcon,
  },
  "10745": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ACHeatIcon,
  },
  "10840": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MaterialStoneIcon,
  },
  "10746": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MaterialStoneIcon,
  },
  "10747": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: NuclearEnergyMessageIcon,
  },
  "10749": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: AppliancesFridgeIcon,
  },
  "10750": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: VegetablesPlateIcon,
  },
  "10751": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: AppliancesStove,
  },
  "10752": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: RenewableEnergyWindTurbine,
  },
  "10753": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterFountainSinkIcon,
  },
  "10754": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ModernTvRemoteIcon,
  },
  "10839": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: RealEstateActionHouseKeyIcon,
  },
  "10755": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: RealEstateActionHouseKeyIcon,
  },
  "10833": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MatchesFireIcon,
  },
  "10756": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MatchesFireIcon,
  },
  "10835": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GardeningWateringPipeIcon,
  },
  "10836": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ParkingP1Icon,
  },
  "10837": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LiftIcon,
  },
  "10838": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MailboxInIcon,
  },
  "10841": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: StairsAscendIcon,
  },
  "10842": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LaundryMachineIcon,
  },
  "10843": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WarehouseStorageIcon,
  },
  "10847": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GarbageBinIcon,
  },
  "10844": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GarbageBinIcon,
  },
  "10845": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BikingPersonIcon,
  },
  "10846": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: SkunkIcon,
  },
  "10905": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GarbageBinIcon,
  },
  "10901": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BuildingIcon,
  },
  "10902": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: FamilyOutdoorsPlayhouseIcon,
  },
  "10903": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: FamilyOutdoorsTeeterIcon,
  },
  "10904": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: IceRoadIcon,
  },
  // DENMARK
  "11178": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LaundryMachine2Icon,
  },
  "11181": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LightBulbIcon,
  },
  "11187": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: SafetyFireAlarm,
  },
  "11190": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ACHeatIcon,
  },
  "11200": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BathroomMirrorCabinet,
  },
  "11216": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: HumidityHigh,
  },
  "11234": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BathroomShowerIcon,
  },
  "11241": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ArchitectureDoor,
  },
  "11250": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterFountainSinkIcon,
  },
  "11253": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LaundryMachine1Icon,
  },
  "11257": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterProtectionFaucet,
  },
  "11263": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ToiletSeatIcon,
  },
  "11268": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WenchIcon,
  },
  "11173": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: HardwareNutsRound,
  },
  "11212": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: AppliancesSlowCooker,
  },
  "11214": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterFountainSinkIcon,
  },
  "11221": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: StoveInductionPot,
  },
  "11229": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: TemperatureSnowflake,
  },
  "11205": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LoginKeys,
  },
  "11986": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: PestBusters,
  },
  "11275": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BikingPersonIcon,
  },
  "11278": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: AppliancesOven,
  },
  "11281": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: RealEstateDimensionsPlan1,
  },
  "11282": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LiftIcon,
  },
  "11285": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: SafetyFireAlarm,
  },
  "11288": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ParkingP1Icon,
  },
  "11291": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GarbageThrow,
  },
  "11295": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: StairsPersonDescend,
  },
  "11298": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LoginKeys,
  },
  "11304": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: LaundryMachine1Icon,
  },
  "11311": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: MailboxInIcon,
  },
  "11317": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: SkunkIcon,
  },
  "11319": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: FocusFlower,
  },
  "11321": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WarehouseStorage2,
  },
  "11322": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: GarbageBinIcon,
  },
  "11325": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ArchitectureDoor,
  },
  "11334": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WaterProtectionFaucet,
  },
  "11989": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: PestBusters,
  },
  "11270": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: ColorRollingBrush,
  },
  "11271": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: BuildingIcon,
  },
  "11272": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: FamilyOutdoorsPlayhouseIcon,
  },
  "11273": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: FamilyOutdoorsTeeterIcon,
  },
  "11274": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: IceRoadIcon,
  },
  "11988": {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: PestBusters,
  },
  [problemKey]: {
    categoryKey: FailureCategoryLabelKey.SPECIFIC_PROBLEM,
    icon: WenchIcon,
  },
  [generalKey]: {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: WayfindingTicket,
  },
  [customerComplaintKey]: {
    categoryKey: FailureCategoryLabelKey.TYPE,
    icon: HeadphonesSupport,
  },
  [CustomerComplaintReason.NEIGHBOUR_COMPLAINT]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: SmileyAngry,
  },
  [CustomerComplaintReason.COMPLAINT_REGARDING_HEIMSTADEN]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: PlantSad,
  },
  [CustomerComplaintReason.GARBAGE]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: GarbageBinIcon,
  },
  [CustomerComplaintReason.NOISE_FROM_CONSTRUCTION_WORK]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: ConstructionDrill,
  },
  [CustomerComplaintReason.OTHER]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: FolderQuestion,
  },
  [CustomerComplaintReason.SMOKE_ODOR]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: InductionPot,
  },
  [CustomerComplaintReason.SUGGESTIONS_FROM_IMPROVEMENTS]: {
    categoryKey: FailureCategoryLabelKey.CATEGORY,
    icon: ScienceBrain,
  },
};
